jQuery(document).ready(function () {
    readMore();
    toggleBlockManualInternalLinking();
    toggleSearchform();
    gtranslateModifyDropdown();

    jQuery('.powergut-slider__slick').slick({
        "slidesToShow": 6,
        "slidesToScroll": 1,
        "dots": false,
        "responsive": [
            {
                "breakpoint":1439,
                "settings":{
                    slidesToShow: 4
                }
            },
            {
                "breakpoint":767,
                "settings":{
                    slidesToShow: 2
                }
            },
        ]
    });


    gsap.config({
        nullTargetWarn: false,
    });

    // Slider
    if(jQuery('.pgut-slider').length > 0){
        jQuery('.pgut-slider .pgut-arrow').click(function(){
            scrollingLeft(jQuery(this));
        });
    }
});

function gtranslateModifyDropdown(){
    jQuery(".gtranslate_wrapper select option").each(function() {
        var langCode = jQuery(this).val().replace('fr|', '');
        jQuery(this).text(langCode.toUpperCase()); // Replace with language code
    });
}

var counter_effect = false;
jQuery(window).scroll(function(){
    // Activer l'effet Compteur quand on arrive dessus
    if(jQuery('.pgut-counter__number').length > 0){
        var top_window = jQuery('.pgut-counter__number').offset().top - window.innerHeight;
        if(!counter_effect && jQuery(window).scrollTop() > top_window){
            counterEffect();
            counter_effect = true;
        }
    }
});


// Animation de compteur de chiffres
function counterEffect() {
    jQuery('.pgut-counter__number').each(function () {
        var $this = jQuery(this);
        var split_string = $this.text().split(",");
        // Pour les nombres à décimales
        // On coupe la chaine en 2 et on fait deux compteurs différents
        if(split_string.length > 1){
            $this.html("<span class='pgut-counter__number-part'>"+split_string[0]+"</span>,<span class='pgut-counter__number-part'>"+split_string[1]+"</span>");
            jQuery.each(split_string, function(i, $val){;
                $val = $this.find('.pgut-counter__number-part').eq(i).text();
                jQuery({ Counter: 0 }).animate({ Counter: $this.find('.pgut-counter__number-part').eq(i).text() }, {
                    duration: 1000,
                    easing: 'swing',
                    step: function (now) {
                        $this.find('.pgut-counter__number-part').eq(i).text(Math.ceil(now).toLocaleString('fr'));
                    }
                });
            });
        }
        else {
            jQuery({ Counter: 0 }).animate({ Counter: $this.text() }, {
                duration: 1000,
                easing: 'swing',
                step: function (now) {
                    $this.text(Math.ceil(now).toLocaleString('fr'));
                }
            });
        }



    });
}

function initSortByPosts(){
    if(jQuery('#pgut-sort-by').length > 0){
        jQuery('#pgut-sort-by').on('change', function(){
            var sortValue = jQuery(this).val();
            var currentUrl = new URL(window.location.href);
            var params = new URLSearchParams(currentUrl.search);

            // Update the sort_by parameter
            params.set('sort_by', sortValue);

            // Reload the page with the updated query parameters
            window.location.href = currentUrl.pathname + '?' + params.toString();
        });
    }
}

function readMore(action = 'hide'){
    let elements =  jQuery('.js-read-more');

    if (action === 'hide') {
        elements.each(function () {
            let parent = jQuery(this);
            let read_content = parent.nextAll().detach();
            let content_block = jQuery(this).closest('.wp-block-group').find('.js-read-more-content').appendTo(parent.parent());
            read_content.appendTo(content_block);
        });
    }

    elements.click(function (e) {
        e.preventDefault();

        let tl = gsap.timeline();
        tl.to(jQuery(this), {ease: 'power0', opacity: 0, overflow: 'hidden', display: 'none'});
        tl.to(jQuery(this).parent().next(), {
            ease: 'power0', opacity: 1, height: 'auto', onComplete: function () {
                ScrollTrigger.refresh();
            }
        });
    });
}
function toggleBlockManualInternalLinking(){
    // Block Internal Linking - Ouvrir / Fermer les accordéons
    if(jQuery('.pgut-manual-internal-linking').length > 0){
        jQuery('.pgut-manual-internal-linking .pgut-manual-internal-linking__heading').click(function(){
            jQuery(this).parent().toggleClass('open');
        });
    }
}

function toggleSearchform(){
    if(jQuery('.pgut-search').length > 0) {
        jQuery('.pgut-search__content').on('click', function () {
            jQuery(this).parent().toggleClass('pgut-search__open');

            if(jQuery(this).parent().hasClass('pgut-search__open')){
                jQuery('#pgut-searchform > input[type="text"]').focus();
            }
        });

        jQuery('.pgut-search__content__opened .pgut-icon').on('click', function () {
            jQuery(this).closest('.pgut-search').toggleClass('pgut-search__open');
        });
    }
}

// Scroll to left or right inside an element
function scrollingLeft(element_arrow) {
    var width_scroll = element_arrow.closest('.pgut-slider').find('.pgut-slide').width()+18;
    var scroll_left = 0;
    if(element_arrow.hasClass('pgut-arrow-left')){
        scroll_left = "-="+width_scroll+"px";
    }
    else {
        scroll_left = "+="+width_scroll+"px";
    }
    element_arrow.closest('.pgut-slider').find('.pgut-slider__container').animate({
        scrollLeft: scroll_left
    }, "slow");
}

var $lastWindowTop = 0;
jQuery(window).scroll(function(){
    $lastWindowTop = stickyHeader($lastWindowTop);
});

function stickyHeader($lastWindowTop)
{
    let $direction_up = false;
    var $windowTop = jQuery(window).scrollTop();
    if($windowTop < $lastWindowTop)
        $direction_up = true;

    if($windowTop > 100) {
        jQuery('header').addClass('pgut-is-sticky');

        if($direction_up) {
            jQuery('header').addClass('pgut-is-sticky__up');
        }
        else{
            jQuery('header').removeClass('pgut-is-sticky__up');
        }
    }
    else if($windowTop < 300) {
        jQuery('header').removeClass('pgut-is-sticky');
        jQuery('header').removeClass('pgut-is-sticky__up');
    }

    return $windowTop;
}